var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tubber-layout layout layout--account"},[_c('header-container'),_c('nuxt'),_c('lazy-hydrate',{attrs:{"when-visible":""}},[_c('copyright-container')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }